export default __webpack_public_path__ + "static/media/Gunderland Boots.18cb0901.jpg";